module.exports = __webpack_public_path__ + "img/photography.de3939ee.svg";